/**
 * templates module
 */
export default {
  'views/templates/wireless': () => import('@/views/templates/wireless/index.vue'),
};
